/**
*  Module for collapsable areas
*/

const PinchAndZoom = function() {
  /**
   *  Private Properties/Methods
   */

  require('../lib/hammer.js');

  function init(image) {
    const mc = new Hammer.Manager(image);

    const pinch = new Hammer.Pinch();
    const pan = new Hammer.Pan();

    pinch.recognizeWith(pan);

    mc.add([pinch, pan]);

    let adjustScale = 1;
    let adjustDeltaX = 0;
    let adjustDeltaY = 0;

    let currentScale = null;
    let currentDeltaX = null;
    let currentDeltaY = null;

    // Prevent long press saving on mobiles.
    image.addEventListener('touchstart', function (e) {
      e.preventDefault();
    });

    // Handles pinch and pan events/transforming at the same time;
    mc.on('pinch pan', function (ev) {
      const transforms = [];

      // Adjusting the current pinch/pan event properties using the previous ones set when they finished touching
      currentScale = adjustScale * ev.scale;
      currentScale = currentScale < 1 ? 1 : currentScale;
      currentDeltaX = adjustDeltaX + (ev.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (ev.deltaY / currentScale);

      // Concatinating and applying parameters.
      transforms.push('scale('+currentScale+')');
      transforms.push('translate('+currentDeltaX+'px,'+currentDeltaY+'px)');
      image.style.transform = transforms.join(' ');

    });


    mc.on('panend pinchend', function () {
      // Saving the final transforms for adjustment next time the user interacts.
      adjustScale = currentScale;
      adjustDeltaX = currentDeltaX;
      adjustDeltaY = currentDeltaY;

    });
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init
  };
};

module.exports = PinchAndZoom;